import videojs from 'video.js'

export type {
  AdBreakData,
  AdData,
  AdState,
  SmartlibConfiguration,
  SmartlibPlugin,
} from './core/addons/smartlib'
export type { Configuration, Options } from './core'
export type { ExternalError } from './components/error-display'
export type { ExtOComponent, TAutoplay, TPlayer } from 'video.js'
export type { MasterManifestData } from './core/addons/stream-stats'
export type { PlayerProps } from './Player'
export type { PlayerRef } from './videojs'
export type { QualityLevel } from './core/index.h'
export type {
  SkipSegment,
  SkipSegmentType,
} from './components/skip-segment/skip-segment.h'

export {
  addLanguage,
  getPlaybackSessionId,
  preacquireWakeLock,
  setPlaybackSessionId,
  supportedDrmsResolved,
} from './core'
export {
  alternativePlayer,
  defaultPlayer,
  trailerPlayer,
} from './components/player'
export { EMPTY_AD_STATE } from './core/addons/smartlib'
export { Events } from './shared/events'
export { Intent } from './shared/types/intent'
export { isCmcdEnabled } from './core/addons/cmcd'
export { mapError } from './components/error-display'
export { MAX_AUTO_QUALITY } from './shared/types/quality'
export { MediaError } from './shared/media-error'
export { Message, mq } from './shared/mq'
export { Player } from './Player'
export { setLogger } from './shared/logger'
export { setPlayerDebugMode } from './shared/constants/debug'
export * from './core/addons/chromecast/index.h'
export * from './shared/constants/classes'
export * from './shared/types/tracks'

// values for google pal nonce generation
export const name = 'videojs'
export const version = (videojs as any).VERSION
